import {
  ActionTypes,
  FetchEvaluationsStartAction,
  FetchEvaluationsSuccessAction,
  FetchEvaluationsFailAction,
  ClearEvaluations,
} from './types';

const fetchEvaluationsByUserStart = (): FetchEvaluationsStartAction => ({
  type: ActionTypes.FETCH_EVALUATIONS_START,
});

const fetchEvaluationsByUserSuccess = (payload: []): FetchEvaluationsSuccessAction => ({
  type: ActionTypes.FETCH_EVALUATIONS_SUCCESS,
  payload,
});

const fetchEvaluationsByUserFail = (payload: string): FetchEvaluationsFailAction => ({
  type: ActionTypes.FETCH_EVALUATIONS_FAIL,
  payload,
});

const clearEvaluations = (): ClearEvaluations => ({
  type: ActionTypes.CLEAR_EVALUATIONS,
});

export { fetchEvaluationsByUserStart, fetchEvaluationsByUserSuccess, fetchEvaluationsByUserFail, clearEvaluations };
